import { z } from 'zod';
const EquipmentRuleTypeSchema = z.enum(['assignment', 'period']);
export type EquipmentRuleType = z.infer<typeof EquipmentRuleTypeSchema>;
export const RuleAndPolicySearchSchema = z.object({
  ruleType: EquipmentRuleTypeSchema.default('assignment')
});